import type { IconName } from "@verbleif/lib/src/components/Icon/icons";

export const REPORT_VIEW_SIDEBAR_LABEL_KEYS: Record<string, string> = {
  all: "reports.sidebar.assign_all",
  pinned: "reports.sidebar.pinned",
  open: "reports.sidebar.typeOpen",
  closed: "reports.sidebar.typeClosed",
  created_by_me: "reports.sidebar.created_by_me",
  guest: "reports.sidebar.public",
  transferred: "reports.sidebar.typeTransfered",
};

export const REPORT_VIEW_DEFAULT_ICON: IconName = "list-check";
export const REPORT_VIEW_DEFAULT_ICON_COLOR_CLASS = "text-primary-500 dark:text-primary-400";

/**
 * The default report view that is not a view: the per-object list (`defaultReportView: per_property`). No report view
 * can have this key, and it never has a scope; Reports opens the per-object list instead of a view.
 */
export const REPORT_PER_OBJECT_DEFAULT_VIEW = "per_property";
export const REPORT_PER_OBJECT_LABEL_KEY = "reports.sidebar.perObject";
export const REPORT_PER_OBJECT_ICON: IconName = "house";
